(function () {
  // Only Green / 250ml Cup is on sale right now, but the other variants still exist in
  // Shopify (100ml, Bundle and White are paused, not deleted, and CJdropshipping manages
  // their inventory so it can't be zeroed out). This pins every option to its live value
  // in the theme instead. The pickers are hidden via CSS (see theme.liquid), so this only
  // has to keep the underlying selected variant correct: on load, and again after any
  // option change in case that ever moves the selection.
  //
  // Values are matched by Shopify's option-value id, not by name or label, so this keeps
  // working in every language (names and labels change per translation, ids never do).
  // To bring a paused option back: remove its id here and its hide rule in theme.liquid.
  var LIVE_VALUE_IDS = ['5670789873842', '5670789775538']; // Green, 250ml Cup

  function lockOptions() {
    LIVE_VALUE_IDS.forEach(function (valueId) {
      var target = document.querySelector('input[data-option-value-id="' + valueId + '"]');
      if (!target || target.checked) return;

      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target && target.matches && target.matches('input[type="radio"][data-option-value-id]')) {
      lockOptions();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockOptions);
  } else {
    lockOptions();
  }
})();
